import React from 'react';

import Settings from '../settings';

var JSZip = require("jszip");

const { $ } = window;

export default class SaveDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toolbar: props.toolbar,
      visible: props.visible
    };

    let project = this.state.toolbar.state.project;
    this.state.format = Settings.get('save-format', 'psd');
    this.state.pages = 'all';
    this.state.specifiedPages = (project && project.pages.length > 0) ? `1-${project.pages.length}` : '';
    this.state.filenames = Settings.get('save-filenames', 'initial');
  }

  componentWillReceiveProps(props) {
    this.setState(props);
  }

  componentDidMount() {
    $('#save-dialog.ui.modal').modal({
      onHidden: () => this.hide(),
      onApprove: () => this.save()
    });

    let self = this;
    $('#save-dialog .ui.checkbox').checkbox({
      onChecked: function(){
        let data = {};
        data[this.name] = this.value;
        self.setState(data);
      }
    });
  }

  componentDidUpdate() {
    $('#save-dialog.ui.modal').modal(this.props.visible ? 'show' : 'hide');
  }

  hide() {
    this.state.toolbar.setState({
      showSaveDialog: false
    });
  }

  update(e) {
    let data = {};
    data[e.target.name] = e.target.value;
    this.setState(data);
  }

  pagesToSave() {
    let project = this.state.toolbar.state.project;
    let pages = [];
    let names = [];

    if (project.pages.length > 0) {
      if (this.state.pages == 'all') {
        pages = project.pages;
      } else if (this.state.pages == 'active') {
        if (project.activePage) {
          pages = [
            project.activePage
          ];
        }
      } else if (this.state.pages == 'specified') {
        let re = /((\d+)\s*\-\s*(\d+)|\d+)/g;
        let matches = this.state.specifiedPages.match(re);

        if (matches) {
          pages = [];
          matches.forEach(match => {
            let from, to;
            if (match.includes('-')) {
              match = match.split('-');
              from = match[0].trim()|0;
              to = match[1].trim()|0;
            } else {
              from = match|0;
              to = match|0;
            }

            if (from > to) {
              let tmp = from;
              from = to;
              to = tmp;
            }

            for (let i = from; i <= to; i++) {
              if (i > 0 && i <= project.pages.length) {
                pages.push(project.pages[i - 1]);
              }
            }
          });
        } else {
          pages = project.pages;
        }
      }

      let extension = '.' + this.state.format;
      if (this.state.filenames == 'initial') {
        names = pages.map(x => x.name + extension);
      } else {
        for (let i = 1; i <= pages.length; i++) {
          names.push(i.toString().padStart(4, '0') + extension);
        }
      }
    }

    return {
      pages: pages,
      filenames: names
    };
  }

  save() {
    let project = this.state.toolbar.state.project;

    Settings.set('save-format', this.state.format);
    Settings.set('save-filenames', this.state.filenames);

    let saveBlob = (filename, blob) => {
      let a = window.document.createElement('a');
      a.href = window.URL.createObjectURL(blob, { type: 'application/octet-stream' });
      a.download = filename;
      document.body.appendChild(a)
      a.click();
      document.body.removeChild(a);
    };

    let pages = this.pagesToSave();
    pages.pages.forEach(page => page.update());
    if (pages.pages.length == 0)
      return;
    if (pages.pages.length == 1) {
      let page = pages.pages[0];
      if (this.state.format == 'psd') {
        saveBlob(pages.filenames[0], new Blob([page.exportToPsd()]));
      } else if (this.state.format == 'png') {
        page.canvas.toBlob(blob => { saveBlob(pages.filenames[0], blob); }, 'image/png');
      } else if (this.state.format == 'jpg') {
        page.canvas.toBlob(blob => { saveBlob(pages.filenames[0], blob); }, 'image/jpeg', 0.95);
      }
    } else {
      project.ready = false;
      project.app.forceUpdate();

      let exportedPagesCount = 0;
      let zip = new JSZip();
      let addFile = (filename, blob) => {
        zip.file(filename, blob);
        exportedPagesCount += 1;
        if (exportedPagesCount == pages.pages.length) {
          zip.generateAsync({ type: 'blob' }).then(blob => {
            saveBlob(project.name + '.zip', blob);

            project.ready = true;
            project.app.forceUpdate();
          });
        }
      };
      pages.pages.forEach((page, index) => {
        let filename = pages.filenames[index];
        if (this.state.format == 'psd') {
          addFile(filename, page.exportToPsd());
        } else if (this.state.format == 'png') {
          page.canvas.toBlob(blob => { addFile(filename, blob); }, 'image/png');
        } else if (this.state.format == 'jpg') {
          page.canvas.toBlob(blob => { addFile(filename, blob); }, 'image/jpeg', 0.95);
        }
      });
    }
  }

  render() {
    let pages = this.pagesToSave();

    return (
      <div className="ui large modal" id="save-dialog">
        <div className="header">
          Сохранение
        </div>
        <div className="scrolling content">
          {this.state.visible && 
            <div className="ui horizontal segments">
              <div className="ui basic segment">
                <div className="ui form">
                  <label>Формат:</label>
                  <div className="inline fields">
                    <div className="field">
                      <div className="ui radio checkbox">
                        <input type="radio" name="format" value="psd" checked={this.state.format == 'psd'} onChange={this.update.bind(this)} />
                        <label>PSD</label>
                      </div>
                    </div>
                    <div className="field">
                      <div className="ui radio checkbox">
                        <input type="radio" name="format" value="png" checked={this.state.format == 'png'} onChange={this.update.bind(this)} />
                        <label>PNG</label>
                      </div>
                    </div>
                    <div className="field">
                      <div className="ui radio checkbox">
                        <input type="radio" name="format" value="jpg" checked={this.state.format == 'jpg'} onChange={this.update.bind(this)} />
                        <label>JPG</label>
                      </div>
                    </div>
                  </div>
                  <label>Страницы:</label>
                  <div className="inline fields">
                    <div className="field">
                      <div className="ui radio checkbox">
                        <input type="radio" name="pages" value="all" checked={this.state.pages == 'all'} onChange={this.update.bind(this)} />
                        <label>все</label>
                      </div>
                    </div>
                    <div className="field">
                      <div className="ui radio checkbox">
                        <input type="radio" name="pages" value="active" checked={this.state.pages == 'active'} onChange={this.update.bind(this)} />
                        <label>текущая</label>
                      </div>
                    </div>
                    <div className="field">
                      <div className="ui radio checkbox">
                        <input type="radio" name="pages" value="specified" checked={this.state.pages == 'specified'} onChange={this.update.bind(this)} />
                        <label>указанные ниже</label>
                      </div>
                    </div>
                  </div>
                  <div className="field">
                    <input type="text" name="specifiedPages" value={this.state.specifiedPages} disabled={this.state.pages != 'specified'} onChange={this.update.bind(this)} />
                  </div>
                  <label>Имена файлов:</label>
                  <div className="inline fields">
                    <div className="field">
                      <div className="ui radio checkbox">
                        <input type="radio" name="filenames" value="initial" checked={this.state.filenames == 'initial'} onChange={this.update.bind(this)} />
                        <label>изначальные</label>
                      </div>
                    </div>
                    <div className="field">
                      <div className="ui radio checkbox">
                        <input type="radio" name="filenames" value="numeric" checked={this.state.filenames == 'numeric'} onChange={this.update.bind(this)} />
                        <label>числовые</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ui segment thumbnails">
                {pages.pages.map((page, index) => (
                  <div className="thumbnail" key={index}>
                    <div className="image">
                      <img src={page.canvas ? page.canvas.toDataURL() : page.source.src} />
                    </div>
                    <div className="title">
                      {pages.filenames[index]}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          }
        </div>
        <div className="actions">
          <button className="ui right primary approve button">Ок</button>
          <button className="ui right cancel button">Отмена</button>
        </div>
      </div>
    );
  }
}
